import { array, boolean, dateTime, defineAction, number, object, string } from '~/prix'
import agentGeolocationAction from './agentGeolocation.action.json'

const agentGeolocationDefinition = defineAction({
  ...agentGeolocationAction,
  userActivityLog: true,
  input: object({
    agentCpf: string(),
    latitude: number(),
    longitude: number(),
    accuracy: number().isOptional(),
    capturedAt: dateTime().isOptional(),
    agentName: string().isOptional(),
    agentPhoto: string().isOptional(),
  }),
  output: object({
    status: string(),
    capturedAt: dateTime(),
    receivedAt: dateTime(),
    positionAccepted: boolean(),
    requestState: string().isOptional(),
    routeCalculatedAt: dateTime().isOptional(),
    arrivedAt: dateTime().isOptional(),
    warnings: array(
      object({
        message: string(),
      }),
    ),
  }),
})

export default agentGeolocationDefinition
